import { FC, useState } from 'react';
import { Box, Tab, Tabs, Typography } from '@mui/material';
import { StatsDateFilter } from '../common/StatsDateFilter';
import LearningSummaryTab from './LearningSummaryTab';
import WordbookTab from './WordbookTab';

const TAB_LABELS = ['전체 요약', '단어장'] as const;

const LearningPage: FC = () => {
    const [tab, setTab] = useState(0);
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');

    const handleDateChange = (start: string, end: string) => {
        setStartDate(start);
        setEndDate(end);
    };

    return (
        <Box sx={{ p: 3 }}>
            <Typography variant="h5" sx={{ mb: 2 }}>
                학습 콘텐츠 통계
            </Typography>

            <Box sx={{ mb: 3 }}>
                <StatsDateFilter onChange={handleDateChange} />
            </Box>

            <Tabs value={tab} onChange={(_, v) => setTab(v)} sx={{ mb: 3 }}>
                {TAB_LABELS.map((label) => (
                    <Tab key={label} label={label} />
                ))}
            </Tabs>

            {startDate && endDate && (
                <>
                    {tab === 0 && <LearningSummaryTab startDate={startDate} endDate={endDate} />}
                    {tab === 1 && <WordbookTab startDate={startDate} endDate={endDate} />}
                </>
            )}
        </Box>
    );
};

export default LearningPage;
